module.exports = __webpack_public_path__ + "static/media/accessories.e9082bdd.jpg";